import { render, staticRenderFns } from "./sets.vue?vue&type=template&id=6b2afcb8&"
import script from "./sets.vue?vue&type=script&lang=js&"
export * from "./sets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports